<div class="container-fluid">
    <div class="profile">
        <div class="col-xs-12 col-sm-6">
            <carousel v-if="perfmedia && performer" v-on:navigateTo="navigateSlides" :photos="perfmedia" :performer="performer" :currentImage="currentSliderSelected"></carousel>
            <div class="slides">
                <div class="slides__slide col-xs-3" v-for="(photo, index) in perfmedia" :class="{ 'current': index === currentSliderSelected}" v-on:click="navigateSlides('select', index)">
                    <img :src="getSliderImages(performer, photo, '')" />
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-6">
            <div class="profile__info"  v-if="performer">
                <h1>{{ performer.nickname }}</h1>
                <div class="profile__info-content">
                    <p class="live">{{ $t('profile.directlive') }}</p>
                    <p class="number">{{ $t('profile.call') }}<span> {{ content.settings.phone }}</span><i>{{ content.settings.phonecost | currency }} {{ $t('header.cost') }}</i></p>
                    <p>{{ $t('profile.keypress', { advert: performer.advertId }) }}</p>
                </div>
                <button class="call" v-on:click="startCall()">{{ $t('profile.calldirect') }}<span>{{ content.settings.phonecost | currency }} {{ $t('header.cost') }}</span></button>
                <div class="profile__info-content">
                    <h2>{{ $t('profile.bio') }}</h2>
                    <ul>
                        <li><span class="left" v-t="'profile.age'"></span><span class="right text-bold">{{ performer.age }}</span></li>
                        <li><span class="left" v-t="'profile.cupsize'"></span><span class="right text-bold">{{ breastSize(performer.cupSize) }}</span></li>
                        <li v-if="performer.weight>0"><span class="left" v-t="'profile.weight'"></span><span class="right text-bold">{{ performer.weight }}</span></li>
                        <li><span class="left" v-t="'profile.height'"></span><span class="right text-bold">{{ performer.height }}</span></li>
                        <li><span class="left" v-t="'profile.eyecolor'"></span><span class="right text-bold">{{ eyeColor(performer.eyeColor) }}</span></li>
                        <li><span class="left" v-t="'profile.location'"></span><span class="right text-bold">{{ performer.location }}</span></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-xs-12 nopad">
            <div class="profile__info" v-if="performer">
                <br />
                <div class="profile__info-content">
                    <h2>{{ $t('profile.desc') }}</h2>
                    <span>{{ performer.description }}</span>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/components/pages/profile.tpl.html